import { usePaymentsMethodsApi } from '@entities/payment-method'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void usePaymentsMethodsApi()
})
